//actions to get shipping fees
import axios from 'axios';
import { API_URL } from '../variables';
export const FETCH_SHIPPING_FEES_REQUEST = 'FETCH_SHIPPING_FEES_REQUEST';
export const FETCH_SHIPPING_FEES_SUCCESS = 'FETCH_SHIPPING_FEES_SUCCESS';
export const FETCH_SHIPPING_FEES_FAILURE = 'FETCH_SHIPPING_FEES_FAILURE';

export const fetchShippingFees = () => async (dispatch) => {
    dispatch({ type: FETCH_SHIPPING_FEES_REQUEST });
    try {
      const response = await axios.post(`${API_URL}/api/orders/shipping-fees/get`, {
        page: 1,
        pagination: 10000
      });
      dispatch({ type: FETCH_SHIPPING_FEES_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: FETCH_SHIPPING_FEES_FAILURE, payload: error.message });
    }
  };
